<template>
    <AppLayout
        page="/help-categories"
        pageTitle="Help"
        :class="$page.props.staffView ? null : 'container'"
    >
        <v-container fluid class="animate__animated animate__fadeIn">
            <v-row justify="space-around" class="mb-4">
                <v-col cols="12" sm="8" md="6" lg="4">
                    <Search />
                </v-col>
            </v-row>
            <v-row>
                <!--<v-col
                    v-for="card in categories"
                    :key="card.id"
                    cols="12"
                    sm="8"
                    md="6"
                    lg="4"
                >
                    <v-card
                        class="soli-round"
                        @click="
                            $inertia.visit(
                                route('help-categories.show', card.id)
                            )
                        "
                    >
                        <v-container>
                            <v-card-title class="text-center primary--text">{{
                                card.title
                            }}</v-card-title>
                        </v-container>
                    </v-card>
                </v-col>-->
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    v-for="card in categories"
                    :key="card.id"
                >
                    <v-hover v-slot="{ hover }">
                        <v-card
                            :elevation="hover ? 12 : 2"
                            hover
                            light
                            :class="{
                                'on-hover': hover,
                            }"
                            class="soli-round"
                            style="border: none"
                            @click="visit(card)"
                        >
                            <div
                                v-if="$vuetify.breakpoint.smAndUp"
                                class="contents"
                            >
                                <v-img
                                    :height="196"
                                    :src="
                                        card.imagePath
                                            ? `/api/image-service/240x240/${card.imagePath}`
                                            : card.photo_url
                                    "
                                    class="align-end half-round"
                                    gradient="to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)"
                                >
                                    <v-card-title
                                        class="white--text font-weight-bold text-h5"
                                        >{{ card.title }}</v-card-title
                                    >
                                </v-img>

                                <v-card-actions class="flex justify-end pa-3">
                                    <v-btn
                                        class="soli-round"
                                        outlined
                                        color="primary"
                                        >View Articles</v-btn
                                    >
                                </v-card-actions>
                            </div>
                            <v-card-actions v-if="$vuetify.breakpoint.xsOnly">
                                <v-list>
                                    <v-card-title
                                        class="font-weight-bold soli-grey pb-0"
                                        >{{ card.title }}</v-card-title
                                    >
                                    <v-btn
                                        class="soli-round ml-1"
                                        text
                                        small
                                        color="primary"
                                        ><span :class="{ underline: hover }"
                                            >View Article</span
                                        >
                                        <v-icon small
                                            >chevron_right</v-icon
                                        ></v-btn
                                    ></v-list
                                ><v-spacer />
                                <v-avatar size="96" class="soli-round"
                                    ><v-img
                                        :src="
                                            card.imagePath
                                                ? `/api/image-service/96x96/${card.imagePath}`
                                                : card.photo_url
                                        "
                                        class="align-end"
                                        gradient="to bottom, rgb(255 255 255 / 0%), rgba(25, 73, 114, .75)"
                                    ></v-img></v-avatar
                            ></v-card-actions> </v-card
                    ></v-hover>
                </v-col>
            </v-row>
        </v-container>
    </AppLayout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import { Link } from "@inertiajs/vue2";
import Search from "../../Components/HelpArticles/Search";
import GlobalSearch from "../../Components/GlobalSearch.vue";
import CRMDrawer from "../../Layouts/CRMDrawer.vue";

export default {
    layout: CRMDrawer,
    components: {
        AppLayout,
        Link,
        Search,
        GlobalSearch,
    },
    props: {
        categories: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {};
    },
    methods: {
        visit(card) {
            if (card.redirect_url) return (window.location = card.redirect_url);
            this.$inertia.visit(route("help-categories.show", card.id));
        },
        showCategory(e) {
            console.log(e);
            e.preventDefault();

            Inertia.get(e.target.href);
        },
    },
};
</script>
